module.exports = __webpack_public_path__ + "img/banner.54e572ae.png";